import { useTranslation } from '@/lib/i18n/i18n.client';

import { Text } from '@/decodo/components/atoms/Text';

import IconCheckCircle from '~/icons/check-circle.svg';
import IconBestValueProvider2023 from '~/svg/IconBestValueProvider.svg';
import IconBestValueProvider2024 from '~/svg/IconBestValueProvider-2024.svg';

export function InfoPage() {
  const { texts } = useTranslation();

  const features: (keyof typeof texts.contact_sales.form.features)[] = [
    '65M_ips',
    'advanced_scraping',
    'full_anonymity',
    'free_tools',
  ];

  return (
    <div className='relative hidden flex-col justify-center bg-gray-900/50 p-10 md:flex'>
      <div className='before:absolute before:inset-0 before:size-full before:bg-gray-900/10 before:backdrop-blur-sm'>
        <Text className='text-base-white text-h1 relative font-serif'>
          {texts.contact_sales.form.efficient_web_data_collection}
        </Text>
        <ul className='relative mt-10 flex flex-col gap-y-6'>
          {features.map((feature) => (
            <li key={feature} className='flex items-center gap-x-3'>
              <IconCheckCircle className='text-brand-500 h-6 w-6' />
              <Text className='text-base-white text-body-l font-mono'>
                {texts.contact_sales.form.features[feature]}
              </Text>
            </li>
          ))}
        </ul>
        <div className='relative mt-20 flex items-center gap-x-6'>
          <IconBestValueProvider2024
            className='h-12 text-gray-400'
            data-tracker-context='contact-sales-form_award-1'
          />
          <IconBestValueProvider2023
            className='h-12 text-gray-400'
            data-tracker-context='contact-sales-form_award-2'
          />
        </div>
      </div>
    </div>
  );
}
